<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <div>
      <div class="bodyCenter">
        <div class="modalStyle">
          <div class="titulos">
            <div class="seccionTitle">
              <em class="fa fa-cog mLeft"></em>
              <div class="headerTxt mLeft">
                Tratamientos Adicionales por Doctor
              </div>
            </div>
            <div class="seccionCodigo">
              <div>Tx_adic_dr</div>
            </div>
          </div>

          <div class="flxDivs">
            <br />
            <b-form-group
              label="Solicitante"
              class="mginInputTrt"
              label-align="left"
            >
              <span class="inputIconDiv">
                <v-select
                  style="width: 100%"
                  label="nombre"
                  :filterable="false"
                  :options="colaboradores"
                  @search="getColaboradores"
                  :reduce="(colaborador) => colaborador.id"
                  v-model="empId"
                  placeholder=""
                >
                  <template slot="no-options">Sin datos</template>
                </v-select>

                <b-button
                  variant="primary"
                  disabled
                  v-if="loadingColaboradores"
                >
                  <b-spinner small></b-spinner>
                </b-button>
              </span>
            </b-form-group>

            <br />
            <b-form-group
              label="Especialidad"
              label-align="left"
              class="mginInputTrt"
            >
              <b-form-select
                v-model="idEspecialidad"
                :options="especialidadArray"
                :disabled="empId == null"
                @change="obtenerTratamientos(idEspecialidad)"
              ></b-form-select>
            </b-form-group>

            <div class="flexDivsTrts">
              <div class="divItmTrt">
                <b-table
                  :sort-by.sync="sortBy"
                  sticky-header
                  ref="selectableTable"
                  selectable
                  :select-mode="selectMode"
                  :items="tratamientosArray"
                  :fields="fields"
                  @row-selected="onRowSelected"
                  responsive="sm"
                >
                  <template #cell(Seleccion)="{ rowSelected }">
                    <template v-if="rowSelected">
                      <span aria-hidden="true">&check;</span>
                      <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                      <span aria-hidden="true">&nbsp;</span>
                      <span class="sr-only">Not selected</span>
                    </template>
                  </template>

                  <template #cell(Tratamiento)="row">
                    <p class="trtItem">
                      {{ row.item.Tratamiento }}
                    </p>
                  </template>
                </b-table>
              </div>
              <div class="divItmTrtEnmedio">
                <b-button
                  v-if="$localStorageService.can('CA_11_agregar_tratam')"
                  variant="primary"
                  :disabled="selected.length == 0"
                  @click="addTrts"
                  >Agregar</b-button
                >
                <br />
                <br />
                <b-button
                  v-if="$localStorageService.can('CA_11_quitar_tratam')"
                  variant="primary"
                  :disabled="selectedQuitar.length == 0"
                  @click="quitTrts"
                  >Quitar</b-button
                >
              </div>
              <div class="divItmTrt">
                <b-table
                  :sort-by.sync="sortBy"
                  sticky-header
                  ref="selectableTable"
                  selectable
                  :select-mode="selectMode"
                  :items="tratamientosArrayAdicionales"
                  :fields="fieldsAdic"
                  @row-selected="onRowSelectedAdicionales"
                  responsive="sm"
                >
                  <template #cell(Seleccion)="{ rowSelected }">
                    <template v-if="rowSelected">
                      <span aria-hidden="true">&check;</span>
                      <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                      <span aria-hidden="true">&nbsp;</span>
                      <span class="sr-only">Not selected</span>
                    </template>
                  </template>

                  <template #cell(Tratamiento)="row">
                    <p class="trtItem">
                      {{ row.item.Tratamiento }}
                    </p>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <br />
          <b-button
            v-if="$localStorageService.can('CA_11_guardar_tratam')"
            variant="primary"
            :disabled="btnDisabled == true || empId == null"
            @click="guardar"
            >Guardar</b-button
          >
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import miniToastr from "mini-toastr"; //ES6
import _ from "lodash";
import Header from "../components/Header.vue";
export default {
  name: "TratamientoAdicionales",
  props: {
    msg: String,
  },
  components: {
    Header,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    especialidadArray: null,
    idEspecialidad: null,
    colaboradores: [],
    empId: null,
    loadingColaboradores: false,
    fields: [{ key: "nombreTratamiento", label: "Tratamientos disponibles" }],

    fieldsAdic: [
      {
        key: "nombreTratamiento",
        label: "Tratamientos permitidos adicionales",
      },
    ],
    sortBy: "idTratamiento",
    selectMode: "multi",
    selected: [],
    tratamientosArray: [],
    selectedQuitar: [], // SECCION QUITAR
    tratamientosArrayAdicionales: [],
    btnDisabled: false,
  }),

  methods: {
    guardar() {
      var list = JSON.parse(JSON.stringify(this.tratamientosArrayAdicionales));
      this.$http
        .post(this.$api + "tratamientos/actualizarTratamientosDoctor", {
          idEmpleado: this.empId,
          listaTrts: list,
          idUsuario: this.$localStorageService.getIdUsuario(),
        })
        .then((response) => {
          if (response.status === 200) {
            var message = response.data.message
              ? response.data.message
              : "Se guardo correctamente el registro";
            miniToastr.success(message);
            this.$swal({
              icon: "success",
              title: "Se actualizó correctamente",
              showConfirmButton: false,
              timer: 2500,
            });
          }
        })
        .catch((error) => {
          var message = error.response.data.message
            ? error.response.data.message
            : "Error al crear el registro";
          miniToastr.info(message);
          this.btnDisabled = false;
        })
        .finally(() => {
          this.btnDisabled = false;
        });
    },
    addTrts() {
      this.selected.forEach((element) => {
        var itm = JSON.parse(JSON.stringify(element));
        this.tratamientosArrayAdicionales.push(itm);
        const updateArrayTrts = this.tratamientosArray.filter(
          (item) => item.idTratamiento !== itm.idTratamiento
        );
        this.tratamientosArray = updateArrayTrts;
      });
    },
    quitTrts() {
      this.selectedQuitar.forEach((element) => {
        var itm = JSON.parse(JSON.stringify(element));
        this.tratamientosArray.push(itm);
        const updateArrayTrts = this.tratamientosArrayAdicionales.filter(
          (item) => item.idTratamiento !== itm.idTratamiento
        );
        this.tratamientosArrayAdicionales = updateArrayTrts;
      });
    },
    onRowSelected(items) {
      this.selected = items;
    },
    onRowSelectedAdicionales(items) {
      this.selectedQuitar = items;
    },
    obtenerTratamientos(id) {
      const parametros = {idEspecialidad: id}
      this.$http
        .post(
          this.$api + "tratamientos/obtenerTratamientos", parametros
        )
        .then((response) => {
          if (response.status === 200) {
            this.tratamientosArray = response.data.data
              .map((it) => {
                return {
                  idTratamiento: it.idTratamiento,
                  nombreTratamiento: it.nombre,
                };
              })
              .filter(function (item) {
                return item.idTratamiento != "";
              });
            //comparando si es un array los adicionales

            if (this.tratamientosArrayAdicionales.length != 0) {
              var data1 = this.tratamientosArray;
              var data2 = this.tratamientosArrayAdicionales;
              var data3 = [];

              _.each(data1, function (objeto) {
                var elemento_en_data2 = _.find(data2, objeto);

                if (elemento_en_data2 === undefined) {
                  data3.push(objeto);
                }
              });

              this.tratamientosArray = data3;
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    llenarEspecialidades() {
      this.$http
        .get(this.$api + "catalogos/obtenerEspecialidades")
        .then((response) => {
          if (response.status === 200) {
            var arrayRespuesta = response.data.data.map((it) => {
              return {
                value: it.id,
                text: it.especialidad,
                color: it.color,
              };
            });
            this.especialidadArray = arrayRespuesta.filter(function (item) {
              return item.value != 0;
            });
            this.especialidadArray.push({ value: 0, text: "TODAS" });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getColaboradores(searchTerm) {
      if (searchTerm === "") {
        this.loadingColaboradores = false;
        return false;
      }
      if (searchTerm != undefined && searchTerm.length > 10) {
        this.tratamientosArray = [];
        this.tratamientosArrayAdicionales = [];
        this.idEspecialidad = null;
        this.loadingColaboradores = true;
        var inputTxt = searchTerm.trim().toLowerCase().toUpperCase();
        this.$http
          .get(
            this.$api + "saldo/obtenerDatosEmpleado?nombreEmpleado=" + inputTxt,
            {}
          )
          .then((response) => {
            if (response.status === 200) {
              if (Array.isArray(response.data.data) == true) {
                this.colaboradores = response.data.data;
              }
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => (this.loadingColaboradores = false));
      }
    },
  },
  watch: {
    empId: function (val) {
      if (val !== undefined) {
        this.tratamientosArrayAdicionales = []
        this.colaboradores.forEach((item) => {
          if (val == item.id) {
            if (item.tratamientos.length != 0) {
              const items = JSON.parse(JSON.stringify(item.tratamientos));
              this.tratamientosArrayAdicionales = items
                .map((it) => {
                  return {
                    idTratamiento: it.idTratamiento,
                    nombreTratamiento: it.nombreTratamiento,
                  };
                })
                .filter(function (item) {
                  return item.idTratamiento != "";
                });
            }
          }
        });
      }

      if (val == null) {
        this.tratamientosArrayAdicionales = [];
        this.tratamientosArray = [];
      }
    },
  },
  created() {
    this.llenarEspecialidades();
    this.debug = this.$localStorageService.getDebug();
  },
};
</script>

<style scoped>
.mginInputTrt {
  padding: 10px;
}

.flexDivsTrts {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  height: auto;
}

.divItmTrt {
  width: 40%;
}

.divItmTrtEnmedio {
  width: 10%;
}

.trtItem {
  font-size: 13px;
}
</style>
